export default __webpack_public_path__ + "static/rendition-hd-example-b88b0da413d32419557688fe526d8e85.mp4";